// FastclickJS
import FastClick from 'fastclick';
FastClick.attach(document.body);



// WEBPACK FOOTER //
// ./vendor.js